export default __webpack_public_path__ + "static/media/payment-amex.2353531f.svg";